import React from 'react';

import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import type { ActiveRopaReviewPanel } from 'config/api/ropaReviews/ropaReviews.types';
import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';
import { isReviewLocked } from '../assetRopaReviewHelpers';

type Props = {
  review: ActiveRopaReviewPanel;
};

const RopaReviewClosureBanner: React.FC<Props> = ({ review }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!isReviewLocked(review.status)) {
    return null;
  }

  const isCompleted = review.status === 'completed';

  return (
    <section className={styles.closureBanner}>
      <Typography gutterBottom variant='h3'>
        {t(
          isCompleted
            ? processing_activities_messages.asset_ropa.closure.completed_title
            : processing_activities_messages.asset_ropa.closure.cancelled_title,
        )}
      </Typography>
      <Typography color='textSecondary' variant='body2'>
        {t(
          isCompleted
            ? processing_activities_messages.asset_ropa.closure.completed_body
            : processing_activities_messages.asset_ropa.closure.cancelled_body,
        )}
      </Typography>
      {(review.completionComment || review.cancellationComment) && (
        <Typography className={styles.closureComment} variant='body2'>
          <strong>
            {t(
              isCompleted
                ? processing_activities_messages.asset_ropa.closure.completion_comment
                : processing_activities_messages.asset_ropa.closure.cancellation_comment,
            )}
            :
          </strong>{' '}
          {isCompleted ? review.completionComment : review.cancellationComment}
        </Typography>
      )}
    </section>
  );
};

export default RopaReviewClosureBanner;
